@use '~/theme/theme' as *;

.icon {
  color: color(violet-600);
}
